// extracted by mini-css-extract-plugin
module.exports = {"selectField":"CurrencyDropdown_selectField__iHH5Q","TextField":"CurrencyDropdown_TextField__bAVJF","SelectOptionItem":"CurrencyDropdown_SelectOptionItem__Fe4VV"};